import { css } from '@emotion/react';
import type { FullscreenModalHeaderTheme } from './fullscreen-modal-header-theme';

export const fullscreenModalHeaderStyle = ({ borderColor, spacing }: FullscreenModalHeaderTheme) => css`
  -webkit-app-region: drag;
  height: 60px;
  border-bottom: 1px solid ${borderColor};
  padding: ${spacing(2, 6)};
`;
